// extracted by mini-css-extract-plugin
module.exports = {"translationModeBar":"TranslationModeBar_translationModeBar__363R5","closeButton":"TranslationModeBar_closeButton__1f9qK"};